import { useCallback, useEffect, useState } from 'react';

import { OrderSelectionStatus, useOrderSelectionQuery } from 'generated/graphql-gateway';

import {
  IUseShortCodePollStatus,
  IUseShortCodePollStatusParams,
  ShortCodePollingStatus,
} from './types';

export const useShortCodePollStatus = ({
  loyaltyId,
  skipPolling,
  shortCode,
  pollInterval,
}: IUseShortCodePollStatusParams): IUseShortCodePollStatus => {
  const [pollingStatus, setPollingStatus] = useState<ShortCodePollingStatus>(
    ShortCodePollingStatus.None
  );

  const resetPollingStatus = useCallback(() => {
    setPollingStatus(ShortCodePollingStatus.None);
  }, []);

  // setting pending code state
  useEffect(() => {
    if (!skipPolling) {
      setPollingStatus(ShortCodePollingStatus.Pending);
    }
  }, [skipPolling]);

  const skip =
    skipPolling || !shortCode || !loyaltyId || pollingStatus === ShortCodePollingStatus.None;

  // short code polling
  const { data: pollShortCodeData, error } = useOrderSelectionQuery({
    variables: {
      otp: shortCode!,
    },
    fetchPolicy: 'no-cache',
    skip,
    pollInterval: skip || pollingStatus === ShortCodePollingStatus.Confirmed ? 0 : pollInterval,
  });

  const pollShortCodeStatus = pollShortCodeData?.orderSelection?.status;
  useEffect(() => {
    if (pollShortCodeStatus === OrderSelectionStatus.CLAIMED) {
      setPollingStatus(ShortCodePollingStatus.Confirmed);
    }
  }, [pollShortCodeStatus]);

  useEffect(() => {
    const isNotFoundError = error?.graphQLErrors?.some(err => !!err?.extensions?.['notFound']);
    if (isNotFoundError) {
      setPollingStatus(ShortCodePollingStatus.NotFound);
    }
  }, [error]);

  return {
    pollingShortCodeStatus: pollingStatus,
    resetPollingStatus,
  };
};
